import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTimePickerProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export function RTimePicker({ value, onChange, disabled }: RTimePickerProps) {
    const normalized = value?.slice(0, 5) || '09:00';

    return (
        <StyledInput
            type="time"
            value={normalized}
            onChange={(e) => onChange(e.target.value + ':00')}
            disabled={disabled}
        />
    );
}

const StyledInput = styled('input')({
    padding: '10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.fill,
        color: Colors.mediumGrey,
    },
});
